
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Gemini 프로젝트',
	'appExit': '시작 페이지로 이동',


	'widgetsListLabel': '위젯 목록입니다. 추가하려면 위젯을 선택하고 Enter를 누르십시오.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': '최신',
	'dirty': '최신이 아님',
	'conflict': '보기를 저장하는 중에 충돌 발생',
	'error': '보기를 저장하는 중에 문제점 발생',
	'failure': '서버에 접속할 수 없음',
	'saveFailed': '보기를 저장할 수 없음',

	'wa_insync': '저장됨',
	'wa_conflict': '보기를 저장하는 중에 충돌 발생',
	'wa_error': '보기를 저장할 수 없음',
	'wa_failure': '서버에 접속할 수 없음',

	// Menu Labels
	'changeDisplay': '표시 변경',
	'changeToColumnChart': '열 차트로 변경',
	'changeToBubbleChart': '거품형 차트로 변경',
	'toggleMoveHandles': '이동 핸들 전환',
	'undo': '실행 취소',
	'redo': '다시 실행',
	'mode': '모드 변경',

	'untitled': '제목 없음',
	'remove': '제거',
	'editTitle': '제목 편집',
	'edit': '편집',
	'done': '완료',

	// Data tray
	'dataTrayHandleOpenLabel': '데이터 트레이 열기',
	'dataTrayHandleCloseLabel': '데이터 트레이 닫기',

	// Dialogs
	'dlg_loading': '로드 중...',
	'dlg_ok': '확인',
	'dlg_create': '작성',
	'dlg_cancel': '취소',
	'dlg_close': '닫기',
	'dlg_update': '업데이트',
	'dlg_renameBoardTitle': '이 오브젝트의 이름 바꾸기',
	'dlg_renameDatasetTitle': '이 데이터 세트의 이름 바꾸기',
	'dlg_renameSceneTitle': '이 장면의 이름 바꾸기',
	'dlg_NameLabel': '이름:',
	'dlg_NewNameLabel': '새 이름:',
	'dlg_DefaultNameWithDataSet': '%{name} 뷰',
	'dlg_ShareTitle': '컨텐츠 공유',
	'dlg_UnshareTitle': '컨텐츠 공유 제거',
	'dlg_ShareUser': '사용자 ID:',
	'dlg_NewColumnLabel': '새 계산 이름',

	'dlg_new': '새로 작성...',
	'dlg_open': '열기...',
	'dlg_makeACopy': '사본 작성',
	'dlg_rename': '이름 바꾸기...',
	'dlg_moreToCome': '수행할 추가 조치...',

	'dlg_use': '사용',

	'dlg_RelinkDatasetTitle': '다음으로 데이터 세트 \'%{datasetName}\' 대체...',

	'open_error': '보기를 여는 중에 문제점이 발생했습니다.',

	// Delete Board
	'del_dialogTitle': '삭제 확인',
	'del_itemMsg': '\'%{name}\'을(를) 삭제하시겠습니까?',
	'del_itemsMsg': '%{count} 항목을 삭제하시겠습니까?',
	'del_deleteErr': '\'%{name}\'을(를) 삭제할 수 없음',

	// List Sorting
	'dlg_ascending': '오름차순',
	'dlg_descending': '내림차순',
	'dlg_custom': '사용자 정의',
	'dlg_none': '없음',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': '검색',

	'searchHint': '모든 데이터 검색',
	'clearSearchResult': '검색 결과 지우기',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': '원',
	'shapesHexagon': '육각형',
	'shapesLine': '꺾은선형',
	'shapesOctagon': '팔각형',
	'shapesPentagon': '오각형',
	'shapesSquare': '정사각형',
	'shapesTriangle': '삼각형',
	'shapesDiamond': '다이아몬드',
	'shapesTitle': '모양 특성', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': '모서리가 둥근 사각형',
	'shapesStar': '별 모양',
	'shapesChevron': 'V형 무늬',
	'shapesBadge_ribbon': '뱃지 리본',
	'shapesBadge': '뱃지',
	'shapesHeart': '하트',
	'shapesExclamation': '느낌표',
	'shapesTrendingup': '상향 추세',
	'shapesTrendingdown': '하향 추세',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': '사용자',
	'shapesFemale': '여성',
	'shapesHappyface': '기쁜 얼굴',
	'shapesMale': '남성',
	'shapesMan': '남자',
	'shapesNeutralface': '보통 얼굴',
	'shapesSadface': '슬픈 얼굴',
	'shapesShakehands': '악수',
	'shapesThumbsdown': '엄지 아래로',
	'shapesThumbsup': '엄지 위로',
	'shapesWoman': '여자',

	// Weather and places
	'shapesPlacesWeatherCat': '위치 & 날씨',
	'shapesCity': '구/군/시',
	'shapesCloud': '구름',
	'shapesEducation': '교육',
	'shapesGovernment': '정부',
	'shapesHalfcloud': '흐림',
	'shapesHouse': '집',
	'shapesMoon': '달',
	'shapesRain': '비',
	'shapesSunny': '맑음',

	//Vehicles
	'shapesVehiclesCat': '운송 수단',
	'shapesAirplane': '비행기',
	'shapesCar': '자동차',
	'shapesShip': '배',
	'shapesShoppingcart': '장바구니',
	'shapesTrain': '기차',
	'shapesTruck': '트럭',

	//Objects
	'shapesObjectsCat': '오브젝트',
	'shapesBook': '책',
	'shapesBriefcase': '서류 가방',
	'shapesCalendar': '달력',
	'shapesCheck': '수표',
	'shapesClock': '시계',
	'shapesDesktop': '데스크탑',
	'shapesDocument': '문서',

	'shapesFood': '식음료',
	'shapesGear': '기어',
	'shapesHealth': '건강',

	'shapesIdea': '아이디어',
	'shapesMobile': '모바일',
	'shapesMoney_bill': '지폐',
	'shapesMoney_coin': '동전',
	'shapesPiggybank': '돼지저금통',
	'shapesStackofpaper': '용지',
	'shapesStickynote1': '스티커 메모 1',
	'shapesStickynote2': '스티커 메모 2',
	'shapesTarget': '대상',
	'shapesTool': '도구',

	'shapesUmbrella': '우산',

	'shapesBrain': '두뇌',
	'shapesSkull': '두개골',
	'shapesEye': '눈',

	// Arrows shapes
	'shapesArrowsCat': '화살표',
	'shapesRightArrow': '오른쪽 화살표',
	'shapesLeftArrow': '왼쪽 화살표',
	'shapesDoubleArrow': '이중 화살표',
	'shapesCurvedArrow': '구부러진 화살표',

	// Callouts shapes
	'shapesCalloutsCat': '말풍선',
	'shapesRectCallout': '말풍선',

	// Images
	'imagesCat': '이미지',
	'imageWidgetTitle': '이미지 위젯',
	'imgUrl': '이미지 URL',
	'noImgSelected': '선택한 이미지가 없음',
	'enterImgUrl': '여기에 이미지 URL 입력',
	'imgPasteLink': 'URL을 붙여넣고 Enter를 눌러 저장합니다.',
	'imgResizeToFit': '이미지 크기에 맞게 크기 조정',
	'imgHeight': '높이:',
	'imgWidth': '너비:',
	'imgTransparency': '투명도:',
	'imgMissingUrl': '이미지 URL이 누락되었습니다.',
	'imgUrlValidationError': '이미지 URL이 올바르지 않습니다.',
	'imgUrlInvalidDomainError': '이미지 URL이 관리자가 승인하지 않은 도메인을 가리키고 있습니다. 관리자가 승인한 도메인은 다음과 같습니다. "%{domains}"',

	// line shape
	'propStrokeWidth': '선 두께',
	'propStrokeDashArray': '선 스타일',
	'propStrokeSolidline': '실선',
	'propStrokeLineCap': '줄 마감',
	'propStrokeLineCapButt': '일렬',
	'propStrokeLineCapRound': '원형',
	'propStrokeLineCapSquare': '정사각형',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': '재생',
	'dataPlayerValueListLabel': '데이터 재생기 값',
	// Text Widget
	'textWidgetTitle': '텍스트 위젯',
	'textStyle': '스타일',
	'textStyleDescription': '사전 형식화된 텍스트 스타일',
	'textTitleStyle': '제목',
	'textTitleSmallStyle': '작은 제목',
	'textSubtitleStyle': '부제목',
	'textBodyStyle': '본문',
	'textBodySmallStyle': '작은 본문',
	'textCaptionStyle': '캡션',
	'textQuoteStyle': '인용',
	'textQuoteSmallStyle': '작은 인용',
	'textResponsiveStyle': '자동 크기',
	'textAutoFontSize': '자동',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': '헤어라인',
	'textFontFamilySubClassThin': '얇음',
	'textFontFamilySubClassThinItalic': '얇은 기울임꼴',
	'textFontFamilySubClassExtraLight': '매우 미세함',
	'textFontFamilySubClassExtraLightItalic': '매우 미세한 기울임꼴',
	'textFontFamilySubClassLight': '밝음',
	'textFontFamilySubClassLightItalic': '미세한 기울임꼴',
	'textFontFamilySubClassRegular': '정기',
	'textFontFamilySubClassRegularItalic': '일반 기울임꼴',
	'textFontFamilySubClassItalic': '기울임꼴',
	'textFontFamilySubClassMedium': '중간',
	'textFontFamilySubClassMediumItalic': '중간 기울임꼴',
	'textFontFamilySubClassHeavy': '진함',
	'textFontFamilySubClassHeavyItalic': '진한 기울임꼴',
	'textFontFamilySubClassDemiBold': '반굵게',
	'textFontFamilySubClassDemiBoldItalic': '반굵게 기울임꼴',
	'textFontFamilySubClassBold': '굵게',
	'textFontFamilySubClassBoldItalic': '굵게 기울임꼴',
	'textFontFamilySubClassExtraBold': '매우 굵게',
	'textFontFamilySubClassExtraBoldItalic': '매우 굵게 기울임꼴',
	'textFontFamilySubClassBlack': '검은색',
	'textFontFamilySubClassBlackItalic': '검게 기울임꼴',
	'textFontFamilySubClassStencil': '스텐실',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': '자동 글꼴 크기 조정',
	'responsiveCoachmarkContents': '이 텍스트 유형의 크기를 조정하는 경우 글꼴 크기가 자동으로 조정됩니다. 텍스트 특성에서 글꼴 크기를 설정할 수 있습니다.',

	'propText': '텍스트 세부사항', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': '텍스트 특성', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': '글꼴 크기',
	'textFontFamily': '글꼴 패밀리',
	'textFontWeight': '글꼴 가중치', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Widget Properties
	'propImageLink': '이미지 링크',
	'propMissingURL': 'URL 입력',
	'propImgTop': '이미지 특성', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': '일반 특성', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': '일반', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': '일반', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': '채우기 색상', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': '텍스트 색상', // TODO: becomes "Color" when FF 'PropertiesV2' is enabled
	'propBorderColor': '테두리 색상',
	'propMaintainAxisScales': '축 눈금 유지',
	'propShowItemLabel': '항목 레이블 표시',
	'propHideLegend': '범례 숨기기',
	'propColorPalette': '색상표',
	'propLegendPosition': '범례 위치',
	'propHideAxisTitleLabels': '축 제목 숨기기',
	'propLineColor': '선 색상',
	'propBubbleColor': '거품 색상',
	'propInterpolation': '곡선형',
	'propElementColor': '시각화 요소 색상',
	'propSymbolShape': '기호 모양',
	'propHeatScalePalette': '색상 순서',
	'propHeatScalePalette_tooltipDarkerForLowerValue': '색상이 어두울수록 더 작은 값을 나타냅니다.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': '색상이 어두울수록 더 큰 값을 나타냅니다.',
	'propImageDetails': '이미지 세부사항', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': '웹 페이지 세부사항', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': '매체 세부사항', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'URL을 입력하고 Enter를 누릅니다.',

	//Layout Properties
	'sectionName_positionAndStyle': '위치 및 스타일',
	'propPositionLabel': '위치', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis': 'X', // TODO: becomes 'X position' when FF 'PropertiesV2' is enabled
	'propPositionYAxis': 'Y', // TODO: becomes 'Y position' when FF 'PropertiesV2' is enabled
	'propResizeLabel': '크기', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth': '너비',
	'propResizeHeight': '높이',
	'propRotateLabel': '회전',
	'propRotateAngle': '각도', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': '아이콘 수량',
	'propScaleDescription': '아이콘 수량을 선택하십시오.',
	'propScaleFew': '낮음',
	'propScaleDefault': '기본값',
	'propScaleMany': '높음',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': '이 값은 숫자여야 함',

	'mediaAriaLabel': 'URL 입력',
	'dropdownAriaLabel' : '드롭 다운',
	'ariaGroupLabel': '드롭다운 목록 카테고리: %{cateoryLabel} 항목: %{itemLabel}. 펼치려면 아래로 키를 누르십시오. 탐색하려면 위로 및 아래로 키를 누르고 접으려면 ESCAPE 키를 누르십시오.',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': '마지막 새로 고치기: %{timeInterval} 전',
	'widgetTimer': '위젯 타이머',

	// Theme colors
	'transparent': '색 없음',
	'white': '흰색',
	'lightGrey': '연회색',
	'grey': '회색',
	'darkGrey': '진회색',
	'black': '검은색',
	'lightBlue': '연청색',
	'blue': '파란색',
	'darkBlue': '진청색',
	'yellow': '노란색',
	'orange': '주황색',
	'lime': '라임색',
	'green': '녹색',
	'peach': '복숭아색',
	'red': '빨간색',
	'violet': '보라색',
	'aqua': '바다색',
	'purple': '자주색',
	'plum': '진자주색',
	'gray10': '회색 10',
	'gray20': '회색 20',
	'gray30': '회색 30',
	'gray50': '회색 50',
	'gray60': '회색 60',
	'gray70': '회색 70',
	'gray80': '회색 80',
	'gray90': '회색 90',
	'gray100': '회색 100',
	'blue50': '파란색 50',
	'blue60': '파란색 60',
	'blue70': '파란색 70',
	'green40': '녹색 40',
	'green50': '녹색 50',
	'red50': '빨간색 50',
	'red60': '빨간색 60',


	//Theme Palette Label
	'paletteLabel': 'IBM 색상표 %{number}',
	'heatPaletteLabel': 'IBM 히트 색상표 %{number}',
	'conditionalPaletteLabel': 'IBM 조건부 색상표 %{number}',
	'carbonPaletteXLight': 'Carbon X 밝음',
	'carbonPaletteXDark': 'Carbon X 어두움',
	'carbonPalettePurple': '자주색',
	'carbonPaletteTeal': '암녹색',
	'carbonPaletteCyan': '청록색',
	'carbonPaletteMagenta': '진홍색',
	'carbonPalettePurpleTeal': '자주색 암녹색',
	'carbonPaletteCyanMagenta': '청록색 진홍색',
	'carbonPaletteGreenRed': '녹색 빨간색',
	'carbonPaletteGreenYellowRed': '녹색 노란색 빨간색',
	'carbonPalettePurpleTealConvergent': '자주색 암녹색 수렴',
	'carbonPaletteCyanMagentaConvergent': '청록색 진홍색 수렴',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'IBM 밝은 색상표',
	'userPaletteColor_defaultTheme': 'IBM 기본 색상표',
	'userPaletteColor_darkTheme': 'IBM 어두운 색상표',

	// Dashboard
	'propDashboardBackgroundColor': '배경색',
	'propLayoutPositioning': '레이아웃 위치',
	'propLayoutRelative': '상대',
	'propLayoutAbsolute': '절대값',
	'propLayoutPositioningCoachmarkTitle': '레이아웃 스타일 선택',
	'propLayoutPositioningCoachmarkContent': '상대적 레이아웃에서는 위젯의 크기 및 위치가 화면에 맞게 조정됩니다. 절대적 레이아웃의 위젯은 화면 크기에 관계없이 사용자가 크기를 지정하고 보기에 배치하는 대로 정확하게 표시됩니다.',
	'gridText': '눈금 표시',
	'snapText': '눈금에 맞춤',
	'snapObjectsText': '오브젝트에 맞춤',
	'fitPageText': '페이지 맞춤',
	'gridLabel': '눈금',
	'heightUnit': '높이',
	'widthUnit': '너비',
	'pixelUnit': 'px',
	'propPageSizeLabel': '페이지 크기',
	'propPageSizePresetAriaLabel': '페이지 크기 사전 설정',
	'propPageSizePreset': '사전설정',
	'propPageSizePresetCustom': '사용자 정의',
	'propPageSizePreset16x9': '화면 16:9',
	'propPageSizePreset4x3': '화면 4:3',
	'propPageSizePresetInfographic': '인포그래픽',
	'propPageSizeWidth': '너비',
	'propPageSizeHeight': '높이',
	'propPageSizeWidthAriaLabel': '페이지 크기 너비',
	'propPageSizeHeightAriaLabel': '페이지 크기 높이',
	'propPageSizeAdjustedMessage': '항목이 최소 미만이거나 대시보드에 맞지 않아 페이지 크기가 증가합니다.',
	'propTabShow': '탭 표시',
	'propShowTabsInPreview': '미리보기에서 탭 표시',
	'multilingualDashboardsLabel': '언어',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- 기본값',
	'multilingualDashboardsAddLinkText': '다른 언어 추가',
	'multilingualDashboardsSelect': '선택',
	'multilingualDashboardsButtonLabel': '추가',
	'multilingualDashboardTranslationMode': '이제 번역 모드임(%{currentLanguage})',
	'multilingualDashboardTranslationDone': '완료',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft}개 번역이 남음',
	'multilingualDashboardRemainingString': '1개 번역이 남았음',
	'multilingualDashboardsSetDefault': '기본 언어 설정',
	'multilingualDashboardIconMore': '언어 %{currentLanguage}에 대한 추가 동작',
	'multilingualDashboardIconTranslatableArea': '번역 가능한 영역',
	'multilingualDeleteTitle': '언어 삭제',
	'multilingualDeleteLanguageWarning': '\'%{language}\' 언어를 삭제하시겠습니까?',
	'multilingualSelectLanguage': '언어 선택',
	'confirmLayoutStyleUpgradeTitle': '모든 탭에 적용',
	'confirmLayoutStyleUpgrade': '이 레이아웃 스타일을 대시보드 내의 모든 탭에 적용하시겠습니까?',

	//Tabs
	'tabDeleteDialogPrimaryButton': '삭제',
	'tabDeleteDialogTitle': '이 탭을 삭제하시겠습니까?',
	'tabDeleteDialogMessage': '이 탭의 모든 컨텐츠도 삭제됩니다.',

	// Vis widget
	'propVisTypeReturn': '시각화 유형',
	'propVisDetails': '세부사항',

	// Alignment picker
	'propAlignPickTop': '위쪽 맞춤',
	'propAlignPickRight': '오른쪽 맞춤',
	'propAlignPickBottom': '아래쪽 맞춤',
	'propAlignPickLeft': '왼쪽 맞춤',
	'propAlignPickCenter': '가운데 맞춤',
	'propAlignPicker': '맞춤',

	// Toolbar picker
	'propToolbarPickBold': '굵게',
	'propToolbarPickUnderline': '밑줄',
	'propToolbarPickItalic': '기울임꼴',
	'propToolbarPickJustifyLeft': '왼쪽 맞춤',
	'propToolbarPickJustifyCenter': '가운데 맞춤',
	'propToolbarPickJustifyRight': '오른쪽 맞춤',
	'propToolbarPickJustify': '양쪽 맞춤',

	'propList': '목록',
	'propOrderedList': '정렬된 목록',
	'propUnorderedList': '정렬되지 않은 목록',

	// Symbol shapes
	'propCircle': '원',
	'propTriangle': '삼각형',
	'propSquare': '정사각형',
	'propRect': '직사각형',
	'propStar': '별 모양',
	'propCross': '십자형',
	'propPlus': '더하기',
	'propPoly': '다각형',


	// True and false selection
	'propTrue': 'True',
	'propFalse': 'False',

	// Position selection
	'propLeft': '왼쪽',
	'propRight': '오른쪽',
	'propTop': '상위',
	'propBottom': '하위',

	// Interpolation options
	'propSmooth': '부드럽게',
	'propStraight': '직선',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': '목록', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': '왼쪽으로 이동', // screen reader
	'srWidgetMoveUp': '위로 이동', // screen reader
	'srWidgetMoveRight': '오른쪽으로 이동', // screen reader
	'srWidgetMoveDown': '아래로 이동', // screen reader

	// widget resize
	'srWidgetResizeBigger': '비례하여 크기 늘리기', // screen reader
	'srWidgetResizeSmaller': '비례하여 크기 줄이기', // screen reader
	'srWidgetResizeBiggerV': '세로로 크기 늘리기', // screen reader
	'srWidgetResizeSmallerV': '세로로 크기 줄이기', // screen reader
	'srWidgetResizeBiggerH': '가로로 크기 늘리기', // screen reader
	'srWidgetResizeSmallerH': '가로로 크기 줄이기', // screen reader

	// widget rotate
	'srWidgetRotateCW': '시계방향으로 회전', // screen reader
	'srWidgetRotateCCW': '반시계방향으로 회전', // screen reader

	// Recommended types
	'visChange': '시각화 변경',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': '시각화',
	'chartLabel': '%{chartName} 차트',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': '위젯 내에서 탐색하려면 F12를 누르십시오.',
	'f10KeyDescription': '위젯 포커스 보기를 시작하려면 F10을 누르십시오.',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label}(값 %{value} 포함)',

	'shapeColorLabel': '모양 색상',
	'showLegendLabel': '범례 표시',

	//Webpage
	'webpageWidgetTitle': '웹 페이지 위젯',
	'webpagePasteLink': 'URL을 붙여넣고 Enter를 눌러 저장합니다.',
	'propWebpageLink': '웹 페이지 URL',
	'propWebpageTitle': '웹 페이지 제목',
	'propWebpageTitleDescription': '웹 페이지 제목',
	'webpageUrl': '웹 페이지 URL',
	'noWebpageSelected': '선택된 웹 페이지가 없음',
	'enterWebpageUrl': '여기에 웹 페이지 URL 입력',
	'propWebpageTop': '웹 페이지 특성', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': '웹 페이지 URL이 누락되었습니다.',
	'webpageUrlValidationError': '웹 페이지 URL이 올바르지 않습니다.',
	'webpageHttpValidationError': 'HTTPS 링크를 사용하여 웹 페이지에 액세스해야 합니다.',
	'webpageInvalidDomainError': '웹 페이지 URL이 관리자가 승인하지 않은 도메인을 가리키고 있습니다. 관리자가 승인한 도메인은 다음과 같습니다. "%{domains}"',

	//VizState
	'vzErrorLoading': '시각화를 로드할 수 없음',
	'vzErrorLoadingMissingData': '컨텍스트 데이터가 누락되어 시각화를 로드할 수 없음',

	//Media (Video / Audio)
	'mediaWidgetTitle': '매체 위젯',
	'mediaPasteLink': 'URL을 붙여넣고 Enter를 눌러 저장합니다.',
	'mediaUrl': '매체 URL',
	'noMediaSelected': '선택된 매체가 없음',
	'enterMediaUrl': '여기에 매체 URL 입력',
	'videoHeight': '높이:',
	'videoWidth': '너비:',
	'propMediaLink': '매체 링크',
	'propMediaTitle': '매체 제목',
	'propMediaTitleDescription': '매체 제목',
	'propMediaTop': '매체 특성', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': '매체 링크 URL이 누락됨',
	'mediaUrlValidationError': '매체 파일 URL이 올바르지 않음',
	'mediaUnknownValidationError': '이 유형의 매체가 지원되지 않습니다.',
	'mediaHttpValidationError': 'HTTPS 링크를 사용하여 매체 파일에 액세스해야 합니다.',
	'mediaInvalidDomainError': '매체 파일 URL이 관리자가 승인하지 않은 도메인을 가리키고 있습니다. 관리자가 승인한 도메인은 다음과 같습니다. "%{domains}"',

	// Properties pane
	'commonPropertiesLabel': '특성', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': '데이터 세트',
	'dataViewsLabel': '보기',
	'columnQuality': '데이터 품질',
	'columnProperties': '데이터 특성',

	'dataQuality': '데이터 품질',
	'dataQualityRowCount': '행 수',
	'dataQualityDistribution': '분포',
	'dataRowLabel': '데이터',

	// Modelling UI
	'typeColumn': '유형',
	'modellingColumnType': '유형',
	'modellingColumnAggregation': '집계',
	'modellingColumnUsage': '사용법',
	'modellingColumnSort': '정렬',
	'modellingColumnFormat': '형식',
	'modellingColumnCategory': '카테고리',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': '로드 중...',

	'modellingProcessing': '처리 중...',
	'modellingImport': '가져오기',
	'modellingReimport': '다시 가져오기',
	'modellingDatasourceTitle': '데이터 소스',
	'modellingImportStartedTitle': '가져오기 시작 중',
	'modellingImportStartedText': '데이터를 가져오는 데 시간이 다소 걸릴 수 있습니다.\n\n(데이터를 가져오는 동안 뷰를 작성할 수 있습니다.)',
	'importDatasourceTitle': '연결',
	'dropHere': '새 데이터 소스를 작성하려면 여기에 놓으십시오...',
	'browseButton': '찾아보기',
	'errorNoData': '처리할 데이터가 없습니다.',
	'errorNoFile': '업로드할 파일이 없습니다.',
	'errorUploadFailed': '업로드할 수 없습니다.',
	'uploadSucceessful': '업로드 완료',
	'del_datasourceTitle': '데이터 세트 삭제',
	'del_datasourceMsg': '\'%{name}\'을(를) 삭제하시겠습니까?',
	'modellingFileUpdate': '업데이트',
	'modellingFileUpdateTitle': '데이터 세트 업데이트',
	'modellingFileUpdateDescription': '\'%{name}\'을(를) 업데이트하시겠습니까?',
	'modellingFileUpdatingTitle': '\'%{name}\' 업데이트 중',
	'modellingUpdateStartedTitle': '업데이트 가져오기 시작',
	'modellingUpdateStartedText': '데이터를 업데이트하는 데 시간이 다소 걸릴 수 있습니다.\n\n(데이터를 업데이트하는 동안 뷰를 작성할 수 있습니다.)',
	'modellingErrorImportUploadNoFile': '업로드할 파일이 없습니다.',
	'modellingErrorImportUploadFailed': '업로드할 수 없습니다.',
	'modellingErrorImportUploadInvalidType': '파일 유형이 올바르지 않습니다.',
	'modellingErrorImportUploadTableFailed': '테이블을 가져올 수 없습니다.',
	'modellingIntentResultsTitle': '사용할 제안된 데이터 세트 선택',
	'modellingColumnViewRelationships': '관련 테이블 보기',
	'modellingTableRelatedTables': '\'%{name}\' 관련 테이블',
	'modellingTable': '%{name} - 테이블 ',
	'modellingColumnIncludedInDataSet': '추가됨',
	'modellingDataSet': '데이터 세트',
	'modellingViewInDataSet': '데이터 세트의 보기',
	'modellingViewRelatedTables': '관련된 보기',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': '관련된 테이블을 찾을 수 없음',

	'modellingValidatingDataset': '유효성 검증 중...',
	'datasetFinishedRefreshing': '데이터 세트 %{datasetName}을(를) 새로 고쳤습니다.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': '결합 경로 분석:',
	'modellingJoinColumns': '%{name} 테이블에 대한 결합 경로 정의',
	'modellingJoinToTable': '%{name} 테이블에 결합',

	// Data Quality
	'excluded': '제외',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'm',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': '필터',
	'modellingColumnSortNone': '정렬 지우기',
	'modellingColumnSortAsc': '오름차순 정렬',
	'modellingColumnSortDesc': '내림차순 정렬',
	'modellingColumnRemove': '이 열 제거',

	// Import File Browser
	'dropboxPageTitle': '새 Dropbox 연결',
	'sizeColumn': '크기',

	//Modelling Column Property Values
	'dataType_string': '문자열',
	'dataType_date': '날짜',
	'dataType_integer': '정수',
	'dataType_double': '이중',
	'dataType_float': '부동',
	'dataType_boolean': '부울',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': '개수',
	'defaultAggregation_countdistinct': '고유 수',
	'defaultAggregation_max': '최대값',
	'defaultAggregation_min': '최소값',
	'defaultAggregation_avg': '평균값',
	'defaultAggregation_sum': '합계',
	'defaultAggregation_auto': '자동(%{aggregationType})',

	'type_fact': '팩트',
	'type_attribute': '속성',

	'defaultSort_none': '정렬하지 않음',
	'defaultSort_asc': '오름차순 정렬',
	'defaultSort_desc': '내림차순 정렬',

	'category_none': '없음',
	'category_location': '위치',
	'category_monetary': '통화',
	'category_time': '시간',

	// Root menu
	'rootMenuTitle': '기본 메뉴',

	'errorMessageTitle': '오류',
	'errorMessageDetails': '상세 정보: ',
	'errorMessageTitleAssetAlreadyExists': '자산이 이미 있음',

	'defaultTabTitle': '탭 %{index}',
	'tabAddBtnTitle': '새 탭 추가',

	'unsupportedConditionalFormattingEncountered': '일부 열에는 조건부 형식이 더 이상 적용되지 않습니다.',


	// Homepage View
	'nameColumn': '이름',
	'creatorColumn': '작성자',
	'creationDateColumn': '작성 날짜',
	'versionColumn': '버전',
	'modifiedColumn': '마지막 수정 날짜',

	'filterBy': '항목 필터',
	'allFilter': '모든 항목',
	'createdByMeFilter': '내가 작성',
	'sharedWithMeFilter': '나와 공유',
	'favoritesFilter': '내 즐겨찾기',
	'recentsFilter': '최근 추가됨',
	'sortBy': '정렬 기준',

	// Sort Menu
	'sortModified': '수정됨',
	'sortUpdated': '업데이트됨',
	'sortName': '이름',

	'viewAs': '다음으로 보기',
	'thumbnailsView': '축소 그림으로 보기',
	'listView': '목록으로 보기',
	'createMenu': '작성',
	'newAppItem': '대시보드',
	'newDataSet': '데이터 세트',

	'menuSelectionState_a11y': '"%{item}" 선택기가 "%{selectedItem}"(으)로 설정됨',

	'unableToShareItem': '"%{item}" 항목을 공유할 수 없습니다.',
	'toastFetchingContent': '추가 컨텐츠를 가져오는 중...',
	'unableToGetData': '컨텐츠를 가져올 수 없습니다.',
	'unableToFavorite': '즐겨찾기 상태를 변경할 수 없습니다.',
	'hpErrorMissingRequiredOptions': '필수 초기화 옵션이 누락됨',
	'unableToOpenBoard': '"%{name}"을(를) 열 수 없습니다.',
	'unableToDuplicateBoard': '"%{name}"을(를) 복제할 수 없습니다.',
	'unableToCreateBoard': '"%{name}"을(를) 작성할 수 없습니다.',
	'unableToCreateBoardNameConflict': '동일한 이름을 사용하는 자산이 이미 있습니다.',

	// DataSet Detail View
	'status': '상태',
	'numberOfRows': '행',
	'importWarnings': '경고',
	'lineNumbers': '행',
	'excerptFromSource': '발췌',
	'reason': '이유',
	'numberOfRowsDropped': '삭제된 행',
	'oneRowDropped': '한 개의 행이 삭제됨',

	// Type Menu
	'typeMenuLabel': '유형',
	'dashboardsLabel': '대시보드',
	'datasetsLabel': '데이터 세트',
	'storiesLabel': '스토리',
	'allLabel': '모든 유형',

	// Board Page View App Bar
	'datasets': '데이터 세트',
	'settings': '특성',
	'add': '추가',
	'widgets': '위젯',
	'dashboardProperties': '대시보드 특성',
	'searchPanel' : '검색',
	'pins': '콜렉션',
	'pinsOld': '내 핀',
	'pinsDateFilterHeading' : '고정된 날짜',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} 핀 |||| %{smart_count} 핀',
	'pinSearch': '검색',
	'pinSearchOld': '핀 검색',
	'pinListView': '목록 보기',
	'pinIconView': '아이콘 보기',
	'pinRemove': '제거',
	'pinCreate': '작성',
	'pinDeleteError': '콜렉션에서 하나 이상의 자산을 삭제할 수 없습니다. 나중에 다시 시도하십시오.',
	'pinDeleteErrorOld': '하나 이상의 핀을 삭제할 수 없습니다. 나중에 다시 시도하십시오.',
	'pinRetrieveError': '하나 이상의 핀을 검색할 수 없습니다. 나중에 다시 시도하십시오.',
	'NoPinsCollected': '고정된 시각화 없음',
	'pinDeletedToast': '핀이 제거됨',
	'pinAddedToast': '핀이 내 핀에 추가됨',
	'pinningToast': '핀 처리 중...',
	'pinDateFilter': '날짜 필터',
	'pinDateFilterAll': '모두',
	'pinDateFilterToday': '오늘',
	'pinDateFilterYesterday': '어제',
	'pinDateFilterPastWeek': '지난 주',
	'pinDateFilterPastMonth': '지난 달',
	'pinDateFilterEarlier': '이전',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': '제목 편집',
	'toolbarActionSort': '정렬',
	'toolbarActionSortAscending': '오름차순 정렬',
	'toolbarActionSortDescending': '내림차순 정렬',
	'toolbarActionSortAuto': '자동(%{sortOrder})',
	'toolbarActionFormat': '데이터 형식화',
	'toolbarActionFormatAbbreviation': '축약',
	'toolbarActionFormatNone': '자동',
	'toolbarActionFilter': '필터',
	'toolbarActionTopBottom': '맨 위 또는 맨 아래',
	'toolbarActionAddShape': '모양 추가',
	'toolbarActionRmvShape': '모양 제거',
	'toolbarActionToggleShapeDrop': '인포그래픽 모양',
	'toolbarActionToggleShapeDropTitle': '인포그래픽 작성',
	'toolbarActionToggleShapeDropText': '인포그래픽을 작성하려면 모양을 이 필드로 끄십시오.',
	'toolbarActionAggregationType': '요약',
	'toolbarDeleteActionText': '열 제거',
	'toolbarActionFilterLocalKeepSelected': '유지',
	'toolbarActionFilterLocalExcludeSelected': '제외',
	'toolbarActionFilterAllKeepSelected': '필터',
	'toolbarActionSimpleCalculation': '단순 계산',
	'toolbarActionDrillBack': '이전',
	'toolbarActionDrillUp': '드릴 업',
	'toolbarActionDrillDown': '드릴 다운',
	'toolbarActionNavigate': '탐색',
	'toolbarActionCreateFilterGroup': '새 연결 작성',
	'toolbarActionDisconnectFilterGroup': '모든 링크 구분',
	'toolbarActionLinkFilterGroup': '기존 연결에 추가',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': '추가',
	'sidebarMultiselect': '여러 선택사항 전환',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count}이(가) 선택됨',

	'multiselectWithTotalMsg': '%{count}/%{total}',
	'sidebarGoBack': '되돌아가기',

	//DataSet pane
	'errorLoadingDataSets': '이 데이터 세트를 로드할 수 없습니다.',
	'errorLoadingDataSetMetaData': '이 데이터 세트를 로드할 수 없습니다.',
	'dataSetPaneLastUpdated': '마지막 업데이트: %{date}',
	'dataSetPaneDateUnknown': '알 수 없음',
	'sourcePaneLabel': '선택된 소스',
	'addSourceLabel': '소스 추가',
	'find_label': '찾기',
	'navigationPathsLabel': '탐색 경로',

	//widgetlist
	'errorLoadingWidgetList': '오브젝트를 로드할 수 없습니다.',
	'errorLoadingThemeFile': '테마 정의를 로드할 수 없습니다.',
	'errorLoadingLayoutFile': '보기를 로드할 수 없습니다.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': '사용 가능한 시각화 정의를 로드할 수 없습니다.',

	'dwErrorLoadingVisualizationNotFound': '오브젝트에 시각화 정의가 누락되어 해당 오브젝트를 로드할 수 없습니다.',
	'dwErrorLoadingVisualizationListNotFound': '시각화를 로드할 수 없습니다.',
	'dwErrorRunningQuery': '데이터 세트 %{datasetName}에서 데이터를 검색할 수 없습니다.',
	'dwErrorGeoData': '맵에 지리적 데이터를 표시하는 데 문제가 있습니다. 다른 시각화 유형을 선택하십시오. ',
	'dwPromptSignonCancelWarning': '이 시각화의 데이터를 사용할 수 없습니다. 올바른 신임 정보를 제공하십시오.',
	'dwErrorMissingDataset': '연관 데이터 세트 \'%{datasetName}\'을(를) 사용할 수 없으므로 시각화를 로드할 수 없습니다.',
	'dwErrorRenderingVisualization': '이 시각화를 로드할 수 없습니다.',
	'dwErrorVisualizationTooSmall': '포함된 데이터를 표시하기에 시각화의 크기가 너무 작습니다. 시각화 크기를 늘리거나 시각화에 포함되는 데이터를 제한하십시오.',
	'aria_label_datatable': '데이터 테이블',
	'aria_key_navi_datatable_desc': '각 셀로 이동하려면 화살표 키를 누르십시오. 첫 번째 행으로 이동하려면 Control과 Home 키를 누르고, 마지막 행으로 이동하려면 Control과 End 키를 누르십시오.',
	'geomapUnrecognizedLocations': '인식되지 않는 위치:',
	'geomapAmbiguousLocations': '모호한 영역:',

	// custom widget
	'customWidget': '사용자 정의 위젯',
	'customWidgetsTitle': '사용자 정의 위젯',
	'noCustomWidgets': '사용자 정의 위젯 없음',

	// Action names
	'toggleContextBar': '컨텍스트 표시줄 전환',
	'delete': '삭제',
	'share': '공유',
	'unshare': '공유 안함',
	'rename': '이름 바꾸기',
	'close': '닫기',
	'duplicate': '복제',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': '재시도',

	'changeTemplate': '템플리트 변경',

	// Aggregation Types
	'sum': '합계',
	'count': '개수',
	'countdistinct': '고유 수',
	'avg': '평균값',
	'min': '최소값',
	'max': '최대값',
	'custom': '사용자 정의',
	'calculated': '계산됨',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% 변경',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': '시각화 기준...',
	'QuickAddResultsHeader': '데이터 시각화',
	'NoQuickAddResults': '사용자 목적에 일치하는 항목이 없습니다. 새 데이터 세트를 작성하시겠습니까?',
	'NoQuickAddResultsRetry': '일치사항을 찾을 수 없습니다. 다른 용어를 사용하여 다시 시도하십시오.',
	'templateWidgetTitle': '템플리트',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(공백)',

	'nullValueContent': '(값 없음)',
	'nullValueText': '널',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': '텍스트 필터 - %{columnName}',

	'textFilterSelectTab': '선택',

	'textFilterConditionTab': '조건 설정',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': '사용 가능한 항목이 없습니다.',

	'textFilterEquals': '같음',
	'textFilterContains': '포함',
	'textFilterBeginsWith': '시작 문자',
	'textFilterEndsWith': '끝 문자',
	'textFilterDoesNotEqual': '같지 않음',
	'textFilterDoesNotContain': '포함하지 않음',
	'textFilterDoesNotBeginWith': '제외할 시작 문자',
	'textFilterDoesNotEndWith': '제외할 끝 문자',
	'textFilterSampleText': '예: A',

	'textFilterAndButton': '및',
	'textFilterOrButton': '또는',

	'dateFilterMessage': '날짜 범위 선택',
	'dateRangeControlRegionLabel': '날짜 범위 필터 - %{columnName}',
	'dateFilterRangeOption': '범위 옵션',
	'dateFilterDateLabel': '날짜',
	'dateFilterBlank': '(공백)',
	'dateFilterBefore': '이전',
	'dateFilterAfter': '이후',
	'dateFilterBetween': '범위',
	'dateFilterSampleText': 'YYYY-MM-DD',
	'dateTitle': '날짜',
	'dateIncludeBlankLabel': '비어 있는 날짜 포함',

	'timeTitle': '시간',
	'timeFilterMessage': '시간 범위 선택',
	'dateTimeFilterMessage': '날짜 및 시간 범위 선택',

	'topbottomNumberOfResultsLabel': '결과 수',
	'topbottomPercentLabel': '백분율',
	'topbottomNumberOfResultsLimit': '%{lower}-%{higher} 범위',
	'topbottomSelectOption': '맨 위 또는 맨 아래 옵션',
	'topbottomOptionLabel': '표시',
	'searchByLabel': '기준',
	'searchNoMatches': '일치 항목 없음',
	'topbottomRankColumnLabel': '테이블에 등급 열 추가',
	'topbottomNone': '없음',
	'topCount': '상위 개수',
	'topPercent': '상위 %',
	'bottomCount': '하위 개수',
	'bottomPercent': '하위 %',
	'topbottomSearchColumn': '열 찾기',
	'searchColumnAriaLabel': '열을 찾습니다. 검색할 열의 이름을 입력한 후 아래로 화살표를 사용하여 목록에서 열을 찾으십시오.',
	'rankColumnLabel': '등급(%{columnLabel})',
	'topbottomClearLabel': '지우기',

	'rangeFilterControlRegionLabel': '범위 필터 - %{columnName}',

	// Slider
	'sliderRegionLabel': '슬라이더 제어. 슬라이더 핸들을 이동하려면 왼쪽 및 오른쪽 화살표를 사용하십시오.',
	'sliderHandleLabel': '슬라이더 핸들',
	'a11ySliderHandleLabel': '슬라이더 핸들 %{sliderValue}',
	'sliderInputLabel': '값',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': '이 시각화에 사용된 일부 데이터 세트 항목을 사용할 수 없습니다.',
	'datasetItemUnavailable': '이 데이터 세트 항목을 사용할 수 없음',

	//Authoring topBottom
	'topOperator': '상위',
	'bottomOperator': '하위',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value}, 기준: %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': '이 오브젝트만',
	'deleteTopBottom': '상위 또는 하위 개수 삭제',
	'editTopBottom': '상위 또는 하위 개수 편집',
	'deleteDrillState': '현재 드릴 상태 삭제',
	'ariaDeleteDrillStateLabel': '상위 또는 하위 개수를 편집하려면 ENTER 키를 누르십시오.',
	'drillUpStateTitle': '드릴 업',
	'drillDownStateTitle': '드릴 다운',
	'ariaEditTopBottomLabel': '상위 또는 하위 개수를 편집하려면 ENTER 키를 누르십시오.',
	'ariaDeleteTopBottomLabel': '상위 또는 하위 개수를 삭제하려면 DELETE 키를 누르십시오.',

	// Authoring filtering
	'dimFilterIn': '포함: %{in}',
	'dimFilterNotIn': '제외: %{out}',
	'measureFilterBetween': '%{lowerBound} 및 %{upperBound} 범위',
	'measureFilterNotBetween': '%{lowerBound} 및 %{upperBound} 범위 제외',
	'gtFilter': '%{lowerBound} 이후',
	'ltFilter': '%{upperBound} 이전',
	'notGtFilter': '%{lowerBound} 이후 제외',
	'notLtFilter': '%{upperBound} 이전 제외',
	'localFilterTitle': '이 오브젝트만',
	'globalFilterTitle': '모든 오브젝트',
	'deleteFilter': '필터 삭제',
	'editFilter': '필터 편집',
	'ariaEditFilterLabel': '필터를 편집하려면 ENTER 키를 누르십시오.',
	'ariaDeleteFilterLabel': '필터를 삭제하려면 DELETE 키를 누르십시오.',

	// Prompts
	'ariaEditPrompt': '프롬프트 값을 변경하려면 ENTER 키를 누르십시오.',

	'moreDataIndicator': '%{threshold} 항목에서 데이터가 클립되었습니다. 더 적게 표시하려면 필터를 적용하십시오.',

	// data point filtering
	'dataPointFilterTitle': '데이터 점',
	'dataPointFilterIncludeSummary': '%{valueCount} 데이터 점 포함됨',
	'dataPointFilterExcludeSummary': '%{valueCount} 데이터 점 제외됨',

	// DB2 connection page
	'db2Database': 'DB2 데이터베이스(%{jdbcConnection})',
	'db2Title': 'IBM DB2에 연결',

	// Database
	'databaseConnectionMessage': '데이터베이스 연결 상세 정보를 제공하십시오.',
	'connectionString': '데이터베이스 연결 문자열',
	'databaseCredentials': '신임 정보: ',
	'databaseUserName': '사용자 이름',
	'databasePassword': '비밀번호',
	'databaseConnect': '연결',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': '검색어 입력:',
	'twitterKeyword': '키워드',
	'twitterSearch': '검색',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': '뷰를 작성할 수 없음: %{error}\n실패한 조작: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': '위젯 필터',
	'missingColumn': '누락: %{columnLabel}',
	'missingFiltering': '다음 열 ID에서 필터가 누락됨:',
	'heatByLabel': '히트 기준',
	'evColumns': '열',
	'evLocalFilters': '로컬 필터',
	'evExpand': '펼치기',
	'evFilterTooltip': '필터',
	'evAdd': '열 추가',

	// Navigation View
	'navigationBack': '이전',

	// Pinning
	'contentPinFail': '컨텐츠를 수집할 수 없습니다. 나중에 다시 시도하십시오.',
	'contentPinFailOld': '컨텐츠를 고정할 수 없습니다. 나중에 다시 시도하십시오.',

	// Layouts
	'dropZoneLabel': '최대화하려면 여기에 놓기',

	//Share
	'shareDefaultPageTitle': '페이지 %{index}',

	'nextPage': '다음 페이지',
	'previousPage': '이전 페이지',

	'assetAssembly': '보기',

	'toolbar_save': '저장',
	'brgr_saveAs': '다른 이름으로 저장',
	'brgr_refresh': '새로 고치기',

	// Save
	'saving': '저장 중...',
	'save_success': '보기가 저장되었습니다.',
	'save_failure': '죄송합니다. 보기를 저장할 수 없었습니다. 나중에 다시 시도하십시오.',
	'dashboard_save_success': '대시보드가 저장되었습니다.',

	'geminiLeave': '이제 IBM Watson Analytics를 마칩니다.',

	'warning': '경고',
	'missingDataSetData': '이 데이터 세트의 데이터를 사용할 수 없습니다. 데이터 세트를 새로 고치거나 소스 액세스에 대해 관리자에게 문의하십시오.',

	// Calculations
	'error_calculation_in_use': '선택한 계산이 사용 중이므로 삭제할 수 없습니다.',

	'resize': '크기 조정',
	'rotate': '회전',
	'moveHandle': '이동 위젯',
	'expandHandle': '펼치기',
	'panHandle': '이동',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': '이동 위치',

	// Slide out titles
	'shapeSlideoutTitle': '도형',
	'textSlideoutTitle': '텍스트',
	'mediaSlideoutTitle': '매체',
	'visualizationSlideoutTitle': '시각화',

	// Board Model Dialog Messages
	'invalidJSONResponse': '제공된 JSON이 올바르지 않습니다. 자세한 정보는 오류 로그를 참조하십시오.',

	// Widget type labels
	'shape_label': '모양',
	'image_label': '이미지',
	'data_label': '차트',
	'media_label': '매체',
	'text_label': '텍스트',
	'embedMedia_label': '매체',
	'youtube_label': '유튜브 비디오',
	'webpage_label': '웹 페이지',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': '모양',
	'noExtraText_shape_numbered': '모양(%{number})',
	'few_shape': '%{count}개 모양의 그룹',
	'many_shape': '%{count}개 모양의 그룹',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text}개 이미지',
	'one_image_numbered': '%{text}개 이미지(%{number})',
	'noExtraText_image': '이미지',
	'noExtraText_image_numbered': '이미지(%{number})',
	'few_image': '%{count}개 이미지의 그룹',
	'many_image': '%{count}개 이미지의 그룹',
	'noExtraText_text': '비어 있는 텍스트 상자',
	'noExtraText_text_numbered': '빈 텍스트 상자(%{number})',
	'few_text': '%{count}개 텍스트 상자의 그룹',
	'many_text': '%{count}개 텍스트 상자의 그룹',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Cube Viewer',
	'pacubeviewer_named': '%{name} Cube Viewer',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': '%{values}, 기준: %{row_level1} 및 %{column_level1} 교차 분석',
	'crosstab_opt_mapping_numbered': '%{values}, 기준 %{row_level1} 및%{column_level1}(%{number}) 교차 분석',
	'crosstab_has_mapping': '%{values}, 기준: %{row_level1} 교차 분석',
	'crosstab_has_mapping_numbered': '%{values}, 기준: %{row_level1}(%{number}) 교차 분석',
	'crosstab_no_mapping': '비어 있는 교차 분석',
	'crosstab_no_mapping_numbered': '빈 교차 분석(%{number})',
	'crosstab_named': '%{name} 교차 분석',
	'crosstab_named_numbered': '%{name} 교차 분석(%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} 테이블',
	'JQGrid_has_mapping_numbered': '%{grid_cols} 테이블(%{number})',
	'JQGrid_no_mapping': '비어 있는 테이블',
	'JQGrid_no_mapping_numbered': '빈 테이블(%{number})',
	'JQGrid_named': '%{name} 테이블',
	'JQGrid_named_numbered': '%{name} 테이블(%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1} 계층 구조',
	'hierarchy_has_mapping_numbered': '%{level1} 계층 구조(%{number})',
	'hierarchy_no_mapping': '비어 있는 계층',
	'hierarchy_no_mapping_numbered': '빈 계층 구조(%{number})',
	'hierarchy_named': '%{name} 계층 구조',
	'hierarchy_named_numbered': '%{name} 계층 구조(%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories} 맵',
	'map_has_mapping_numbered': '%{categories} 맵(%{number})',
	'map_no_mapping': '비어 있는 맵',
	'map_no_mapping_numbered': '빈 맵(%{number})',
	'map_named': '%{name} 맵',
	'map_named_numbered': '%{name} 맵(%{number})',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual} 요약 값',
	'summary_has_mapping_numbered': '%{actual} 요약 값(%{number})',
	'summary_no_mapping': '비어 있는 요약 값',
	'summary_no_mapping_numbered': '빈 요약 값(%{number})',
	'summary_named': '%{name} 요약 값',
	'summary_named_numbered': '%{name} 요약 값(%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{actual}, 기준: %{sparkline.time} KPI',
	'kpi_opt_mapping_numbered': '%{actual}, 기준: %{sparkline.time} KPI(%{number})',
	'kpi_has_mapping': '%{actual} KPI',
	'kpi_has_mapping_numbered': '%{actual} KPI(%{number})',
	'kpi_no_mapping': '비어 있는 KPI',
	'kpi_no_mapping_numbered': '빈 KPI(%{number})',
	'kpi_named': '%{name} KPI',
	'kpi_named_numbered': '%{name} KPI(%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} 인포그래픽',
	'infographicSummary_has_mapping_numbered': '%{actual} 인포그래픽(%{number})',
	'infographicSummary_no_mapping': '비어 있는 인포그래픽',
	'infographicSummary_no_mapping_numbered': '빈 인포그래픽(%{number})',
	'infographicSummary_named': '%{name} 인포그래픽',
	'infographicSummary_named_numbered': '%{name} 인포그래픽(%{number})',
	'noExtraText_youtube': '유튜브 비디오',
	'noExtraText_youtube_numbered': 'YouTube 비디오(%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} YouTube 비디오',
	'one_youtube_numbered': '%{text} YouTube 비디오(%{number})',
	'few_youtube': '%{count} YouTube 비디오의 그룹',
	'many_youtube': '%{count} YouTube 비디오의 그룹',
	'noExtraText_embedMedia': '매체 링크',
	'noExtraText_embedMedia_numbered': '매체 링크(%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text} 매체 링크',
	'one_embedMedia_numbered': '%{text} 매체 링크(%{number})',
	'few_embedMedia': '%{count} 매체 링크의 그룹',
	'many_embedMedia': '%{count} 매체 링크의 그룹',
	'noExtraText_media': '매체',
	'noExtraText_media_numbered': '매체(%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text} 매체',
	'one_media_numbered': '%{text} 매체(%{number})',
	'few_media': '%{count} 매체의 그룹',
	'many_media': '%{count} 매체의 그룹',
	'noExtraText_webpage': '웹 페이지',
	'noExtraText_webpage_numbered': '웹 페이지(%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text} 웹 페이지',
	'one_webpage_numbered': '%{text} 웹 페이지(%{number})',
	'few_webpage': '%{count} 웹 페이지의 그룹',
	'many_webpage': '%{count} 웹 페이지의 그룹',
	'one_unknown': '오브젝트',
	'one_unknown_numbered': '오브젝트(%{number})',
	'few_unknown': '%{count} 오브젝트의 그룹',
	'many_unknown': '%{count} 오브젝트의 그룹',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': '다음',
	'previous': '이전',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': '현재 탐색 그룹은 %{navigation_group_name}임',

	//Page Context
	'filterBlank': '(공백)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': '필터 값을 로드할 수 없음',
	'editTimelineHighlight': '강조표시 편집',

	'filterDockChevronLeft': '데이터를 통해 스크롤',
	'filterDockChevronRight': '데이터를 통해 스크롤',
	'expand': '펼치기',
	'collapse': '접기',

	//Reset Dashboard
	'dashboardResetTitle': '대시보드 재설정',
	'dashboardResetMessage': '이 대시보드에 적용된 모든 변경사항을 재설정하시겠습니까?',
	'dashboardResetToast': '대시보드가 재설정되었습니다.',

	//Generate PDF
	'buildingPDF': 'PDF 빌드 중...',
	'exportPDF': 'PDF로 내보내기',
	'pageSize': '페이지 크기',
	'orientation': '방향',
	'filtersPresentPDF': '이전 페이지에서 시각화에 적용된 필터:',
	'errorPDF': 'PDF를 생성할 수 없습니다. 새로 고친 후 다시 시도하십시오.',
	'printPDFInfo': '문서 보기',
	'pdfWidget': '위젯',
	'includeFilters': '필터 상세 정보 표시',
	'portrait': '세로',
	'landscape': '가로',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': '대시보드가 업그레이드되었습니다. 최적 성능을 유지하려면 지금 저장하십시오.',

	'ariaFullScreenMessage': '전체 화면을 종료하려면 Esc를 누르십시오.',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} 압축 계층 구조 거품형 차트',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} 압축 계층 구조 거품형 차트(%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': '비어 있는 압축 계층 구조 거품형 차트',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': '빈 압축 계층 구조 거품형 차트(%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} 압축 계층 구조 거품형 차트',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} 압축 계층 구조 거품형 차트(%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{categories}, 기준: %{values} Marimekko 차트',
	'LIVE_marimekko_has_mapping_numbered': '%{categories}, 기준: %{values} Marimekko 차트(%{number})',
	'LIVE_marimekko_no_mapping': '비어 있는 Marimekko 차트',
	'LIVE_marimekko_no_mapping_numbered': '빈 Marimekko 차트(%{number})',
	'LIVE_marimekko_named': '%{name} Marimekko 차트',
	'LIVE_marimekko_numbered': '%{name} Marimekko 차트(%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} 선버스트 차트',
	'LIVE_sunburst_has_mapping_numbered': '%{values} 선버스트 차트(%{number})',
	'LIVE_sunburst_no_mapping': '비어 있는 선버스트 차트',
	'LIVE_sunburst_no_mapping_numbered': '빈 선버스트 차트(%{number})',
	'LIVE_sunburst_named': '%{name} 선버스트 차트',
	'LIVE_sunburst_named_numbered': '%{name} 선버스트 차트(%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': '%{values} 드라이버 분석 차트',
	'LIVE_decision_analysis_has_mapping_numbered': '%{values} 드라이버 분석 차트(%{number})',
	'LIVE_decision_analysis_no_mapping': '비어 있는 드라이버 분석 차트',
	'LIVE_decision_analysis_no_mapping_numbered': '빈 드라이버 분석 차트(%{number})',
	'LIVE_decision_analysis_named': '%{name} 드라이버 분석 차트',
	'LIVE_decision_analysis_named_numbered': '%{name} 드라이버 분석 차트(%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{categories}, 기준 %{columnValue} 및 %{lineValue} 선형 및 세로 막대형 차트',
	'LIVE_line_column_opt_mapping_numbered': '%{categories}, 기준 %{columnValue} 및 %{lineValue} 선형 및 세로 막대형 차트(%{number})',
	'LIVE_line_column_has_mapping': '%{columnValue} 및 %{lineValue} 선형 및 세로 막대형 차트',
	'LIVE_line_column_has_mapping_numbered': '%{categories}, 기준 %{columnValue} 및 %{lineValue} 선형 및 세로 막대형 차트(%{number})',
	'LIVE_line_column_no_mapping': '비어 있는 선형 및 세로 막대형 차트',
	'LIVE_line_column_no_mapping_numbered': '빈 선형 및 세로 막대형 차트(%{number})',
	'LIVE_line_column_named': '%{name} 선형 및 세로 막대형 차트',
	'LIVE_line_column_named_numbered' : '%{name} 선형 및 세로 막대형 차트(%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{x}, 기준: %{y} 및 %{size} 거품형 차트',
	'LIVE_bubble_chart_has_mapping_numbered': '%{x}, 기준: %{y} 및 %{size} 거품형 차트(%{number})',
	'LIVE_bubble_chart_no_mapping': '비어 있는 거품형 차트',
	'LIVE_bubble_chart_no_mapping_numbered': '빈 거품형 차트(%{number})',
	'LIVE_bubble_chart_named': '%{name} 거품형 차트',
	'LIVE_bubble_chart_named_numbered': '%{name} 거품형 차트(%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual} 글머리 기호 차트',
	'LIVE_bullet_has_mapping_numbered': '%{actual} 글머리 기호 차트(%{number})',
	'LIVE_bullet_no_mapping': '비어 있는 글머리 기호 차트',
	'LIVE_bullet_no_mapping_numbered': '빈 글머리 기호 차트(%{number})',
	'LIVE_bullet_named': '%{name} 글머리 기호 차트',
	'LIVE_bullet_named_numbered': '%{name} 글머리 기호 차트(%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': '이 대시보드의 데이터는 다음에 의해 제공됩니다. ',
	'showFooterToggleButtonText': '바닥글 표시',
	'showFooterSectionText': '바닥글'
});
